export const INITIAL_TICK_HISTORY_POINTS = 4800;
export const LINE_VISIBLE_HISTORY_POINTS = 420;
export const CANDLE_SOURCE_HISTORY_POINTS = 4800;
export const MAX_STORED_TICK_HISTORY_POINTS = 7200;
export const FEED_FRAME_MIN_MS = 16;
export const FEED_ANIMATION_RATIO = 0.72;
export const MIN_FEED_ANIMATION_MS = 120;
export const MAX_FEED_ANIMATION_MS = 420;
export const MIN_DISPLAY_PRICE = 0.00000001;
export const TICK_INTERPOLATION_VOLATILITY_RATIO = 0.000048;  // visible micro-noise between real ticks
export const TICK_INTERPOLATION_MIN_VOLATILITY = 0.00000008;
export const TICK_SPIKE_TRIGGER_CHANCE = 0.0012;
export const TICK_SPIKE_COOLDOWN_MIN_FRAMES = 20;
export const TICK_SPIKE_COOLDOWN_MAX_FRAMES = 46;
export const TICK_SPIKE_STRENGTH_MIN = 0.65;
export const TICK_SPIKE_STRENGTH_MAX = 1.25;
export const INTERVAL_CHANGE_LOADER_MS = 1150;
export const SMOOTH_JUMP_BASE_MIN_MS = 160;
export const SMOOTH_JUMP_MAX_MS = 520;
export const SMOOTH_JUMP_DURATION_RATIO_MULTIPLIER = 12000;
export const IDLE_MICRO_MOVE_AFTER_MS = 450;         // 450ms — continuous pulse in Live mode
export const IDLE_MICRO_MOVE_INTERVAL_MS = 450;       // 450ms tick interval
export const IDLE_MICRO_MOVE_RATIO = 0.0000032;
export const IDLE_MICRO_MOVE_MAX_RATIO = 0.0000055;
export const DEFAULT_OVERLAY_GREEN_ALPHA = 0.28;
export const DEFAULT_OVERLAY_RED_ALPHA = 0.28;
export const DEFAULT_CHART_START_PRICE = 1;
export const DEFAULT_CHART_TYPE = "candle";
export const LEFT_EDGE_CLAMP_X = 14;

